import Termly from '@components/termly/Termly';
import { ContentBlock } from '@layouts/ContentBlocks';
import Typography from '@mui/material/Typography';
import { useStyles } from '@ui/utils/makeStyles';
import { makeSeoData } from 'config/next-seo.config';
import { NextSeo } from 'next-seo';
import React from 'react';

const title = 'Guest House Terms and Conditions';
const description = 'Nobody likes surprises when it comes to data and privacy. Here are the terms and conditions for those who use the site and shop with us.';

export default function Privacy() {
  const { theme } = useStyles();

  return (
    <>
      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />
      <ContentBlock
        margin={[2, 'auto', 3]}
        padding={0}
      >
        <Typography
          variant="h1"
          style={{ position: 'relative', top: 75, marginLeft: theme.spacing(3.5) }}
        >
          Terms and Conditions
        </Typography>
        {process.browser && (
          <Termly id="45ff30ee-1ff5-437f-ae06-b3161ee911fc" />
        )}
      </ContentBlock>
    </>
  );
}
